import { render, staticRenderFns } from "./and-clause.vue?vue&type=template&id=2a4abc96&scoped=true"
import script from "./and-clause.vue?vue&type=script&lang=js"
export * from "./and-clause.vue?vue&type=script&lang=js"
import style0 from "./and-clause.vue?vue&type=style&index=0&id=2a4abc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4abc96",
  null
  
)

export default component.exports